import classNames from "classnames";
import * as React from "react";
import { DoorIconProps } from "./DeKaap";

export const DeBeursDeWaal: React.FC<DoorIconProps> = ({
  isActive = false,
}) => {
  return (
    <svg
      width={27}
      height={58}
      viewBox="0 0 27 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className={classNames("gg-transition gg-duration-150 gg-ease-in-out", {
          "gg-fill-[#292747]": isActive,
          "gg-fill-[#9493A3]": !isActive,
        })}
        d="M26.078 0v57.93H0V0zM8.924 55.999h15.188V36.206H8.924zm-6.958 0H7.94V36.206H1.966zm6.958-20.451h15.188V26.99H8.924zm-6.958 0H7.94V26.99H1.966zM24.112 8.757C15.597 9.51 8.924 16.54 8.924 25.103v1.229h15.188zM1.966 26.332H7.94v-1.23c0-9.094 7.113-16.557 16.171-17.315V1.931H1.966z"
        fill="#9493A3"
      />
    </svg>
  );
};
